export default {
  default: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/layouts/default.vue").then(m => m.default || m)
}